import React from 'react';
import { Platform } from '../types/socialGlass';
import { PLATFORM_LOGOS, PLATFORM_LOGO_CLASSES } from '../constants/platforms';

interface PlatformLogoProps {
  platform: Platform;
  className?: string;
}

const PlatformLogo: React.FC<PlatformLogoProps> = ({ platform, className }) => {
  const logoClass = className || PLATFORM_LOGO_CLASSES[platform];
  
  switch (platform.toLowerCase()) {
    case "tiktok":
      return (
        <img src={PLATFORM_LOGOS.tiktok} alt="TikTok Logo" className={logoClass} />
      );
    case "instagram":
      return (
        <img
          src={PLATFORM_LOGOS.instagram}
          alt="instagram logo"
          className={logoClass}
        />
      );
    case "twitter":
    case "x":
      return <img src={PLATFORM_LOGOS.x} alt="Twitter Logo" className={logoClass} />;
    case "youtube":
      return (
        <img src={PLATFORM_LOGOS.youtube} alt="youtube-logo" className={logoClass} />
      );
    default:
      return <p>No logo</p>;
  }
};

export default PlatformLogo;
